const HttpStatusCodes = {
    Ok: 200,
    Created: 201,
    NoContent: 204,
    BadRequest: 400,
    Unauthorized: 401,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    PreconditionFailed: 412,
    InternalServerError: 500,
};

export default HttpStatusCodes;
